import { get } from 'immutable';
import _ from 'lodash';
import moment from 'moment';
import {
  getDataFollowKeyByDot,
  getParamFromSortState,
  getQueryParams,
} from '../../helpers/Common';
import { keyBy } from 'lodash';
import reducerRegistry from '../../helpers/ReducerRegistry';
import {
  getPropertiesValues,
  convertExchange,
  getListRemoveDuplicate,
} from '../../helpers/ArrayUtils';
import rankingService from '../../../core/services/Strategy/RankingService';
import Const from './Const';
import ConstAllScore from './all-score/Const';
import currentState from './../../helpers/CurrentState';
import ConstCommon, { ASC } from './../../common/Const';
import { handleExport } from '../../helpers/HandleExport';
import RankingConst from '../ranking/Const';

const REDUCER_NAME = 'ST_RANKING';
const FETCH_LOAD_LIST_RANKING = `${REDUCER_NAME}FETCH_LOAD_LIST_RANKING`;
const CHANGE_RANKING_LIST = `${REDUCER_NAME}CHANGE_RANKING_LIST`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const FETCH_DATA = `${REDUCER_NAME}FETCH_DATA`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const HOVER_ROW = `${REDUCER_NAME}HOVER_ROW`;
const CHANGE_TAB = `${REDUCER_NAME}CHANGE_TAB`;
const CHANGE_TAB_ALL_SCORE = `${REDUCER_NAME}CHANGE_TAB_ALL_SCORE`;
const LOAD_MORE_RANKINGS = `${REDUCER_NAME}LOAD_MORE_RANKINGS`;
const LOAD_MORE_ALL_SCORE = `${REDUCER_NAME}LOAD_MORE_ALL_SCORE`;
const FETCH_LOAD_LIST_ALL_SCORE = `${REDUCER_NAME}FETCH_LOAD_LIST_ALL_SCORE`;
const CHANGE_ALL_SCORE_LIST = `${REDUCER_NAME}CHANGE_ALL_SCORE_LIST`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;
const CHANGE_ALL_SCORE_SORT_STATE = `${REDUCER_NAME}CHANGE_ALL_SCORE_SORT_STATE`;

const defaultSortState = {
  rank: 'asc',
};

const defaultAllScoreSortState = {
  rtd11: 'desc',
};

export {
  REDUCER_NAME,
  reducer as default,
  changeIndustryDropDown,
  defaultSortState,
  defaultAllScoreSortState,
  intervalFetchRanking,
  changeIdHover,
  changeTabContent,
  changeTabAllScore,
  loadMoreRanking,
  intervalFetchAllScore,
  loadMoreAllScore,
  changeIndustryTableDropDown,
};

const initialState = {
  lstTickerIndustryDrop: [],
  lstTickerIndustryDropByTicker: [],
  listTickerRanking: [],
  listRankingLoadMore: [],
  listRankingByTicker: {},
  listTickerAllScore: [],
  listAllScoreByTicker: {},
  listAllScoreByTickerOrg: {},
  listAllScoreLoadMore: [],
  currentSelectedIndustryTable: ConstAllScore.itemAllIndustries,
  code: Const.defaultCode,
  indexData: {},
  id: '',
  currentDefaultIndex: '',
  listDefaultIndex: [],
  listDefaultIndexByKey: {},
  industryType: Const.defaultOption,
  isLoading: false,
  RankingId: 0,
  totalPage: 10,
  checkFlag: 0,
  firstPage: 0,
  organCodeHover: '',
  component: {},
  currentItemSearch: {},
  page: 1,
  sortState: defaultSortState,
  allScoreSortState: defaultAllScoreSortState,
};

const getComGroupCode = currentTabAllScore => {
  const mapComGroupCode = {
    [RankingConst.listTabFilterAllScore.all]: '',
    [RankingConst.listTabFilterAllScore.HOSE]: 'VNIndex',
    [RankingConst.listTabFilterAllScore.HNX]: 'HnxIndex',
  };

  return mapComGroupCode[currentTabAllScore];
};

export const changeSortState = sortState => ({
  type: CHANGE_SORT_STATE,
  payload: sortState,
});

export const changeAllScoreSortState = sortState => ({
  type: CHANGE_ALL_SCORE_SORT_STATE,
  payload: sortState,
});

export const downloadAllScore = (apiParam, fileName = 'export-file') => {
  return () => {
    rankingService.downloadAllScore(apiParam).then(response => {
      handleExport(response, fileName);
    });
  };
};

export const downloadRanking = (apiParam, fileName = 'export-file') => {
  return () => {
    rankingService.downloadRanking(apiParam).then(response => {
      handleExport(response, fileName);
    });
  };
};

export const downloadIndicators = (apiParam, fileName = 'export-file') => {
  return () => {
    rankingService.downloadIndicators(apiParam).then(response => {
      handleExport(response, fileName);
    });
  };
};

function changeIndustryDropDown(value) {
  return dispatch => {
    currentState.add(ConstCommon.listComponent.STRanking, 'industryId', value);

    dispatch({
      type: CHANGE_RANKING_LIST,
      payload: {
        industryId: value,
      },
    });
    dispatch(intervalFetchRanking(value));
  };
}

function changeIndustryTableDropDown(currentSelectedIndustryTable) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_ALL_SCORE_LIST,
      payload: {
        currentSelectedIndustryTable,
      },
    });
  };
}

const changeIdHover = item => (dispatch, getState) => {
  const currentItemSearch = item || {};
  const organCode = item ? item.organCode || '' : '';
  const { currentTab, industryId, currentTabAllScore } = getState()[
    REDUCER_NAME
  ];
  const ComGroupCode = getComGroupCode(currentTabAllScore);
  const { icbCode } = getState()[REDUCER_NAME].currentSelectedIndustryTable;
  const apiParam = {
    icbCode,
    OrganCode: organCode,
    ComGroupCode,
  };

  if (currentTab === 1) {
    //do ranking
    dispatch(intervalFetchRanking(industryId, organCode));
  } else {
    //do all score
    dispatch(intervalFetchAllScore(true, apiParam));
  }

  dispatch({
    type: HOVER_ROW,
    payload: {
      organCode,
      currentItemSearch,
    },
  });
};

function loadMoreRanking(params) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const store = getState();
    const listTickerRanking = store[REDUCER_NAME].listTickerRanking;
    const formatParams = formatedParams(params);
    const page = formatParams.Page;
    const rankingId = params.rankingId;
    rankingService.getDataRanking(formatParams).then(response => {
      let { items = [] } = response === null ? [] : response || [];
      const { totalCount = 0 } = response === null ? 0 : response || [];
      const totalPage = calcTotalPage(totalCount);
      convertExchange(items);
      dispatch({
        type: LOAD_MORE_RANKINGS,
        payload: {
          listRankingLoadMore: items,
          rankingId,
          page,
          totalPage,
          listTickerRanking,
        },
      });
      dispatch(setLoading(false));
    });
  };
}

function intervalFetchRanking(Code = Const.industryId, OrganCode = null) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const sortState = getState()[REDUCER_NAME].sortState;
    const formatParams = formatedParams({
      Code: Code,
      OrganCode,
      ...getParamFromSortState(sortState),
    });
    rankingService.getDataRanking(formatParams).then(response => {
      let { items = [] } = response === null ? [] : response || [];
      const { totalCount = 0 } = response === null ? 0 : response || [];
      const totalPage = calcTotalPage(totalCount);
      convertExchange(items);
      dispatch({
        type: FETCH_LOAD_LIST_RANKING,
        payload: {
          listRanking: items ? items : [],
          totalPage,
        },
      });
      dispatch(setLoading(false));
    });
  };
}

function objectListAllScore(getState, value) {
  const store = getState();
  const obj = {
    listTickerAllScore: store[REDUCER_NAME].listTickerAllScore,
    listAllScoreByTicker: store[REDUCER_NAME].listAllScoreByTickerOrg,
    currentTabAllScore: store[REDUCER_NAME].currentTabAllScore,
    currentSelectedIndustryTable:
      store[REDUCER_NAME].currentSelectedIndustryTable,
  };
  let valueSelectedIndustry = value
    ? value
    : store[REDUCER_NAME].currentSelectedIndustryTable;
  valueSelectedIndustry = !_.isEmpty(valueSelectedIndustry)
    ? valueSelectedIndustry.icbCode === Const.icbCodeDefault
      ? {}
      : valueSelectedIndustry
    : {};
  obj.listIcbCode = getPropertiesValues(valueSelectedIndustry, 'icbCode');
  return obj;
}

function loadMoreAllScore(params) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const objLstAllScore = objectListAllScore(getState);
    const formatParams = formatedParams(params, false);
    const page = formatParams.Page;
    const scoreId = params.scoreId;
    const { icbCode } = getState()[REDUCER_NAME].currentSelectedIndustryTable;
    const optionalParams = {};
    optionalParams.IcbCode = icbCode === 'all' ? null : icbCode;
    rankingService
      .getAllScore({ ...formatParams, ...optionalParams })
      .then(response => {
        let { items = [] } = response === null ? [] : response || [];
        const { totalCount = 0 } = response === null ? 0 : response || [];
        const totalPage = calcTotalPage(totalCount);
        convertExchange(items);
        dispatch({
          type: LOAD_MORE_ALL_SCORE,
          payload: {
            listAllScoreLoadMore: items,
            scoreId,
            page,
            totalPage,
            ...objLstAllScore,
          },
        });
        dispatch(setLoading(false));
      });
  };
}

function intervalFetchAllScore(isReload, params) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const sortState = getState()[REDUCER_NAME].allScoreSortState;
    const objLstAllScore = objectListAllScore(getState);
    const icbCode = getState()[REDUCER_NAME].currentSelectedIndustryTable
      .icbCode;
    const formatParams = formatedParams(
      {
        IcbCode: icbCode,
        ...params,
        Code: Const.industryId,
        ...getParamFromSortState(sortState),
      },
      false,
    );
    rankingService.getAllScore(formatParams).then(response => {
      let { items = [] } = response === null ? [] : response || [];
      const { totalCount = 0 } = response === null ? 0 : response || [];
      const totalPage = calcTotalPage(totalCount);
      items = items ? items : [];
      convertExchange(items);
      dispatch({
        type: FETCH_LOAD_LIST_ALL_SCORE,
        payload: {
          ...objLstAllScore,
          listTickerAllScore: items || [],
          totalPage,
          isReload,
        },
      });
      dispatch(setLoading(false));
    });
  };
}

function changeTabContent(currentTab) {
  currentState.add(
    ConstCommon.listComponent.STRanking,
    'currentTab',
    currentTab,
  );

  return dispatch => {
    dispatch({
      type: CHANGE_TAB,
      payload: {
        tab: currentTab,
      },
    });
  };
}

// function filterByExchange(currentTabAllScore, listData) {
//   let results = listData;
//   if (!_.isEmpty(results)) {
//     if (currentTabAllScore === Const.listTabFilterAllScore.HOSE) {
//       results = _.filter(
//         results,
//         v => v.nameAndExchange === Const.listTabFilterAllScore.HOSE,
//       );
//     } else if (currentTabAllScore === Const.listTabFilterAllScore.HNX) {
//       results = _.filter(
//         results,
//         v => v.nameAndExchange === Const.listTabFilterAllScore.HNX,
//       );
//     }
//   }
//   return results;
// }

function changeTabAllScore(currentTabAllScore) {
  return (dispatch, getState) => {
    const objLstAllScore = objectListAllScore(getState);

    currentState.add(
      ConstCommon.listComponent.STRanking,
      'currentTabAllScore',
      currentTabAllScore,
    );

    dispatch({
      type: CHANGE_TAB_ALL_SCORE,
      payload: {
        ...objLstAllScore,
        currentTabAllScore,
      },
    });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function getDataFilterAllScore(payload) {
  let {
    listAllScoreLoadMore,
    listTickerAllScore,
    listAllScoreByTicker,
    isReload,
  } = payload;
  if (isReload) {
    listAllScoreByTicker = {};
  }
  const lstTickerLoadMore = !_.isEmpty(listAllScoreLoadMore)
    ? listAllScoreLoadMore.map(item =>
        getDataFollowKeyByDot(item, Const.organCode),
      )
    : [];
  listAllScoreByTicker = !_.isEmpty(listAllScoreByTicker)
    ? listAllScoreByTicker
    : keyBy(listTickerAllScore, Const.organCode);

  let lstTicker = !_.isEmpty(lstTickerLoadMore)
    ? [...listTickerAllScore, ...lstTickerLoadMore]
    : listTickerAllScore;

  let lstTickerLoadMoreByTicker = getListRemoveDuplicate(
    lstTicker,
    listAllScoreLoadMore,
    Const.organCode,
  );

  let obj = {
    listAllScoreByTickerOrg: {
      ...listAllScoreByTicker,
      ...lstTickerLoadMoreByTicker,
    },
  };

  // obj.lstTickerLoadMoreByTicker = keyBy(
  //   filterByExchange(
  //     currentTabAllScore,
  //     filterByList(obj.listAllScoreByTickerOrg, listIcbCode, 'icbCode'),
  //   ),
  //   Const.organCode,
  // );

  obj.lstTickerLoadMoreByTicker = keyBy(
    obj.listAllScoreByTickerOrg,
    Const.organCode,
  );
  return obj;
}

function getTabFromQuery() {
  const mapTab = {
    FiinTradeRanking: 1,
    AllScore: 2,
  };

  return mapTab[getQueryParams('tab')];
}

function getCurrentTabAllScore() {
  const mapTab = {
    All: Const.listTabFilterAllScore.all,
    HOSE: Const.listTabFilterAllScore.HOSE,
    HNX: Const.listTabFilterAllScore.HNX,
  };

  return mapTab[getQueryParams('code')];
}

function getIndustryIdFromQuery() {
  if (getQueryParams('tab') !== 'FiinTradeRanking') {
    return undefined;
  }

  return getQueryParams('code');
}

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
        industryId:
          getIndustryIdFromQuery() ||
          currentState.get(ConstCommon.listComponent.STRanking, 'industryId') ||
          Const.industryId,
        currentTab: getTabFromQuery() || 1,
        currentTabAllScore:
          getCurrentTabAllScore() || Const.listTabFilterAllScore.all,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LOAD_LIST_RANKING: {
      const { listRanking } = action.payload;
      const listRankingByTicker = keyBy(
        listRanking,
        Const.listColumn.organCode,
      );
      const listTickerRanking = listRanking.map(item =>
        getDataFollowKeyByDot(item, Const.listColumn.organCode),
      );
      return {
        ...state,
        listTickerRanking,
        listRankingByTicker,
        isLoading: false,
        page: 1,
      };
    }

    case LOAD_MORE_RANKINGS: {
      let {
        listRankingLoadMore,
        totalPage,
        listTickerRanking,
        page,
      } = action.payload;
      const lstTickerLoadMore = listRankingLoadMore.map(item =>
        getDataFollowKeyByDot(item, Const.listColumn.ticker),
      );
      const lstTicker = [...listTickerRanking, ...lstTickerLoadMore];
      const lstTickerLoadMoreByTicker = getListRemoveDuplicate(
        lstTicker,
        listRankingLoadMore,
        Const.listColumn.ticker,
      );
      return {
        ...state,
        listTickerRanking: _.uniq(lstTicker),

        listRankingByTicker: {
          ...state.listRankingByTicker,
          ...lstTickerLoadMoreByTicker,
        },
        rankingId: _.last(lstTickerLoadMore),
        firstPage: 0,
        listRankingLoadMore,
        page,
        totalPage,
      };
    }

    case FETCH_LOAD_LIST_ALL_SCORE: {
      const objLoadMore = getDataFilterAllScore(action.payload);
      const listTickerAllScore = _.keys(objLoadMore.lstTickerLoadMoreByTicker);
      return {
        ...state,
        listTickerAllScore,
        listAllScoreByTicker: objLoadMore.lstTickerLoadMoreByTicker,
        listAllScoreByTickerOrg: objLoadMore.listAllScoreByTickerOrg,
        // scoreId: id,
        isLoading: false,
        page: 1,
      };
    }

    case LOAD_MORE_ALL_SCORE: {
      let { listAllScoreLoadMore, totalPage, page } = action.payload;
      const objLoadMore = getDataFilterAllScore(action.payload);
      const lstTicker = _.keys(objLoadMore.lstTickerLoadMoreByTicker);
      return {
        ...state,
        listTickerAllScore: _.uniq(lstTicker),
        listAllScoreByTicker: objLoadMore.lstTickerLoadMoreByTicker,
        listAllScoreByTickerOrg: objLoadMore.listAllScoreByTickerOrg,
        scoreId: _.last(lstTicker),
        firstPage: 0,
        listAllScoreLoadMore,
        page,
        totalPage,
      };
    }

    case CHANGE_ALL_SCORE_LIST: {
      const { currentSelectedIndustryTable } = action.payload;
      return {
        ...state,
        currentSelectedIndustryTable,
        firstPage: 0,
      };
    }

    case CHANGE_TAB_ALL_SCORE: {
      let { currentTabAllScore } = action.payload;
      const objLoadMore = getDataFilterAllScore(action.payload);
      const listTickerAllScore = _.keys(objLoadMore.lstTickerLoadMoreByTicker);
      return {
        ...state,
        listTickerAllScore,
        listAllScoreByTicker: objLoadMore.lstTickerLoadMoreByTicker,
        currentTabAllScore,
      };
    }

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    case CHANGE_TAB: {
      const { tab } = action.payload;
      return {
        ...state,
        currentTab: tab,
      };
    }

    case CHANGE_RANKING_LIST: {
      const { industryId } = action.payload;

      return {
        ...state,
        industryId,
        checkFlag: 2,
      };
    }

    case HOVER_ROW: {
      return {
        ...state,
        organCodeHover: action.payload.organCode,
        currentItemSearch: action.payload.currentItemSearch,
      };
    }

    case SET_LOADING: {
      return { ...state, isLoading: action.payload };
    }

    case FETCH_DATA: {
      return { ...state, isLoading: action.payload };
    }

    case CHANGE_SORT_STATE:
      return {
        ...state,
        sortState: action.payload,
      };
    case CHANGE_ALL_SCORE_SORT_STATE:
      return {
        ...state,
        allScoreSortState: action.payload,
      };

    default:
      return state;
  }
}

function formatedParams(params = {}, isRanking = true) {
  const formatParams = {
    ...params,
    Page: params.Page || 1,
    PageSize: Const.pageSize,
    time: moment().valueOf(),
    ComGroupCode: params.ComGroupCode || '',
    OrganCode: params.OrganCode || '',
  };
  if (params.IcbCode === 'all' || params.icbCode === 'all') {
    delete formatParams.IcbCode;
    delete formatParams.icbCode;
  }

  if (isRanking) {
    if (params.Code) {
      formatParams.Code = params.Code;
    }
  }

  return formatParams;
}

const calcTotalPage = totalCount => {
  const totalPage = Math.ceil(totalCount / Const.pageSize);
  return totalPage || 0;
};

reducerRegistry.register(REDUCER_NAME, reducer);
